__turbopack_context__.v({
  "container": "EnhancedPlpBanner-module-scss-module__65hXoq__container",
  "content": "EnhancedPlpBanner-module-scss-module__65hXoq__content",
  "desktopImageContainer": "EnhancedPlpBanner-module-scss-module__65hXoq__desktopImageContainer",
  "imageContainer": "EnhancedPlpBanner-module-scss-module__65hXoq__imageContainer",
  "mobileImageContainer": "EnhancedPlpBanner-module-scss-module__65hXoq__mobileImageContainer",
  "textOnRight": "EnhancedPlpBanner-module-scss-module__65hXoq__textOnRight",
  "width": "EnhancedPlpBanner-module-scss-module__65hXoq__width",
});
